import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { ContatoEmpresa } from '../../components'
import * as contatoInstalacaoActionCreators from '../../redux/modules/contatoInstalacao'
import * as flashMessageActionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class ContatoInstalacaoContainer extends Component {

  static propTypes = {
    instalacao: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    multipleContatoInstalacao: PropTypes.object.isRequired,
    fetchMultipleContatoInstalacao: PropTypes.func.isRequired,
    destroyContatoInstalacao: PropTypes.func.isRequired,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    const { instalacao } = this.props
    await this.props.fetchMultipleContatoInstalacao(instalacao.id)
  }

  handleRedirectToNew = (instalacaoId) => {
    this.props.history.push(`/instalacoes/${instalacaoId}/contatos/new`)
  }

  handleEditResource = (instalacaoId, id) => {
    this.props.history.push(`/instalacoes/${instalacaoId}/contatos/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyContatoInstalacao(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('contatoInstalacao', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('contatoInstalacao', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleContatoInstalacao.toList().toJSON(),
      'contatoInstalacao',
      [
        'id',
        'nome',
        'funcao.nome',
        'email',
        'telefone',
        'celular',
        'observacoes',
      ],
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <ContatoEmpresa
        empresaTypePath='instalacoes'
        empresa={this.props.instalacao}
        multipleContatoEmpresa={this.props.multipleContatoInstalacao}
        onRedirectToNew={() => this.handleRedirectToNew(this.props.instalacao.id)}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading}
      />
    )
  }
}

function mapStateToProps ({ contatoInstalacao, status, sort, filter }, {instalacao}) {
  const sortColumn = sort.getIn(['contatoInstalacao', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['contatoInstalacao', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['contatoInstalacao', 'filterText']) || ''

  let map = filterMap(contatoInstalacao, ['nome', 'funcao.nome', 'email', 'telefone', 'celular', 'observacoes'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleContatoInstalacao: map.filter(t => t.get('instalacoes_ids').includes(instalacao.id)),
    sortColumn,
    sortDirection,
    filterText,
    error: status.getIn(['contatoInstalacao', 'error']),
    isLoading: status.getIn(['contatoInstalacao', 'isLoading']),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...contatoInstalacaoActionCreators,
    ...flashMessageActionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContatoInstalacaoContainer))
